export default "__VITE_ASSET__DTGYckER__"